module.exports = __webpack_public_path__ + "static/media/CLicon01.a5207618.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/CLicon01.png
// module id = 1704
// module chunks = 0 1